import React, { useRef, useState, useEffect } from 'react'
import styles from '../../IssueType.module.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import API from '../../../../../ApiConfig'
import { BASE_URL, GET_ACTIVE_FORMS, GET_ALL_COMPLETED_DOCS_ISSUER_ID, USER_TOKEN } from '../../../../../Utils/constant'
import { Delay, _ToNormal } from '../../../../../Utils/helper';
import cogoToast from 'cogo-toast-react-17-fix';
import useRefreshToken from '../../../../../Hooks/usegenerateToken';
import { Icon } from 'react-icons-kit';
import { file } from 'react-icons-kit/feather/file'
import { alignLeft } from 'react-icons-kit/feather/alignLeft'
import SlideUpWrapper from '../../../../../components/Transitions/SlideUpWrapper';
import Breadcrumb from '../../../../../components/Verifier/breadcrumb/BreadCrumb';
import IssuerNavigator from '../../../../../components/DashBoard/IssuerNavigator';
import NavLinks from '../../../../../components/NavLinks';
import NeedHelp from '../../../../Contact Us/NeedHelp';

const SelectForms = ({ ISSUER_ID }) => {
  useRefreshToken(BASE_URL + USER_TOKEN)
  const [docsList, setDocsList] = useState([])
  const [apiData, setApiData] = useState([])
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();

  const handleSelect = (form) => {
    navigate('../forms/selectType', { state: { form } })
  };

  useEffect(() => {
    getDocsList()
  }, [])

  async function getDocsList() {
    setLoading(true)
    API.get(GET_ACTIVE_FORMS + ISSUER_ID)
      .then(res => {
        if (res.status === 200) {
          setApiData(res.data.data)
          setDocsList(res.data.data)
        }
      })
      .catch(err => {
        cogoToast.error(err.message)
      })
      .finally(() => setLoading(false))
  }

  // tabs
  const [MenuLinks, setMenuLinks] = useState([
    // { name: "All Templates", link: 2 },
    { name: "Master Templates", link: 0 },
    // { name: "Custom Templates", link: 1 }
  ])
  const [activeTab, setActiveTab] = useState({ name: "All Credentials", link: 2 })
  const [docType, setdocType] = useState(0)
  function handleActiveTab(e) {
    setActiveTab(e)
  }
  
  useEffect(() => {    
    if (activeTab.link == 2) {
      let lst
      if(docType==0){ 
        lst=apiData
      }
      else{
        lst=apiData.filter(e=>{
          return  e.type==docType
        })
      }
      setDocsList(lst);
    }
    else {
      let lst
      if(docType==0){
        lst = apiData.filter(e => {
          return e.form_type == activeTab.link;
        })
      }
      else{
        lst = apiData.filter(e => {
        return e.form_type == activeTab.link && e.type==docType;
      })}
      setDocsList(lst);
    }
  }, [activeTab, docType])

  // if (selectedOption?.id) {
  //   navigate('/dashboard/details', { state: { selectedOption } })
  // }

  const Card = ({ doc }) => {
    if (doc)
      return (
        <div onClick={e => handleSelect(doc)} className='issuer-container container justify-content-flex-start navItemContainer' style={{ cursor: 'pointer', alignItems: 'center', margin: 0 }}>
          <div className={styles.icon} style={{ padding: '0.5rem', height: '2rem', width: '2rem' }} title={doc?.type == 2 ? 'Document' : 'DocFields'} >
            <Icon icon={doc?.type == 2 ? file : alignLeft} />
          </div>
          <div>
            <div className={styles.title}>
              {doc.form_name}

            </div>
            {/* {doc.master_doc_name} */}
          </div>

        </div>
      )
    else {
      return (
        <div className='issuer-container shimmer' style={{ border: 0, height: '4rem', minWidth: '14rem' }}>
        </div>
      )
    }
  }

  const help = () => (
    <div className="navItemContainer" >
      <span className='navLinkText' style={{ width: 'max-content' }}>For Custom package creation <Link to={'/dashboard/Help/'} className='navLink' style={{ textDecoration: 'underline' }}>contact support</Link></span>
    </div>
  )

  const ShowCards = () => {
    if (loading) {
      return (
        [...Array(3)].map((_, index) => <Card doc={0} />)
      )
    }
    else {
      if (docsList.length > 0)
        return (
          docsList.map(i => <Card doc={i} />)

        )
      else
        return ('No record found')
    }

  }
  return (

    <>
      <SlideUpWrapper>
        <Breadcrumb pos={1} title={'Choose Forms'} category={'verification'} />
        <IssuerNavigator
          title={'Choose Forms'}
          step={'/dashboard'}
          actions={help}
        />
        <div className='issuer-container container justify-content-flex-start navItemContainer' style={{ flexDirection: 'column' }}>
          <div style={{display:"flex", alignItems:"center"}}>
          <NavLinks loading={loading} MenuLinks={MenuLinks} menuClick={handleActiveTab} ischangeRequested={false} />
          <div className={`${styles.tabs} ${docType === 0 ? styles.selectedTab : ""}`} onClick={e=>setdocType(0)}>All</div>
          <div className={`${styles.tabs} ${docType === 1 ? styles.selectedTab : ""}`} onClick={e=>setdocType(1)}>Data-fields</div>
          <div className={`${styles.tabs} ${docType === 2 ? styles.selectedTab : ""}`} onClick={e=>setdocType(2)}>Documents</div>
          </div>
          <div className='container'>
            <div className='justify-content-flex-start navItemContainer' style={{ flexWrap: 'wrap' }}>
              <ShowCards />
            </div>
          </div>
        </div>
        <NeedHelp/>
      </SlideUpWrapper>
    </>
  )
}

export default SelectForms
